import React from 'react';
import Header from '../components/Header';
import SEO from '../components/SEO';

const Impact360ProductPage = () => {
  return (
    <div className="min-h-screen bg-white flex flex-col">
      <SEO 
        title="360 Feedback Assessment Nigeria | Impact 360™ Lagos"
        description="Impact 360™ 360-degree feedback assessment for Nigerian leaders. See how a leader is experienced by the people around them, across five leadership domains. Built for African organisations."
        keywords="360 feedback Nigeria, 360 degree assessment Lagos, multi-rater feedback Nigeria, leadership 360 Africa, Impact 360"
        canonical="https://impactasportal.com/product/impact-360"
      />
      <Header />
      
      {/* Main Content - Iframe Container */}
      <main className="flex-1 pt-20">
        <div className="w-full h-[calc(100vh-80px)]">
          <iframe
            src="https://impactasportal.com/product/impact-360?embed=true"
            title="Impact 360™ - Impact AS Plus"
            className="w-full h-full border-0"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; fullscreen"
            allowFullScreen
            sandbox="allow-same-origin allow-scripts allow-popups allow-forms allow-downloads allow-modals allow-popups-to-escape-sandbox"
          />
        </div>
      </main>
    </div>
  );
};

export default Impact360ProductPage;
